import type { ReactNode } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/atoms/tooltip";
import { ToolbarButton } from "./richTextEditorToolbarButton";
import { RteTooltipWithShortcut } from "./richTextEditorToolbarTooltipContent";

export const ToolbarIconTooltipAction = ({
  tooltipLabel,
  shortcutKeys,
  ariaLabel,
  ariaPressed,
  disabled,
  onClick,
  children,
}: {
  tooltipLabel: string;
  shortcutKeys: readonly string[];
  ariaLabel: string;
  ariaPressed?: boolean;
  disabled?: boolean;
  onClick: () => void;
  children: ReactNode;
}) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <ToolbarButton
        onClick={onClick}
        aria-label={ariaLabel}
        aria-pressed={ariaPressed}
        disabled={disabled}
      >
        {children}
      </ToolbarButton>
    </TooltipTrigger>
    <TooltipContent>
      {shortcutKeys.length > 0 ? (
        <RteTooltipWithShortcut label={tooltipLabel} keys={shortcutKeys} />
      ) : (
        tooltipLabel
      )}
    </TooltipContent>
  </Tooltip>
);
